export default "__VITE_ASSET__MsJwP4Al__"